import decode from 'jwt-decode'
import auth0 from 'auth0-js'
const ID_TOKEN_KEY = 'id_token'
const ACCESS_TOKEN_KEY = 'access_token'
const CURRENT_PAGE_KEY = 'current_page'
const PROFILE_KEY = 'user_profile'
const LOCAL_DATA_KEY = 'local_data_'
const TARGET_PATH_KEY = 'target_path'

const CLIENT_ID = process.env.AUTH0_CLIENT_ID || '' // Appended the "|| ''" so that tests would run
const CLIENT_DOMAIN = process.env.AUTH0_CLIENT_DOMAIN || ''
const REDIRECT = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/callback'
const SCOPE = 'openid profile email app_metadata read:current_user update:current_user_metadata'
const AUDIENCE = process.env.AUTH0_CLIENT_AUDIENCE
const NON_OIDC_NAMESPACE = 'https://app.2dsearch.com/' // Corresponds to namespace used in Auth0 rule

var auth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN
})

export function login () {
  auth.authorize({
    responseType: 'token id_token',
    redirectUri: REDIRECT,
    audience: AUDIENCE,
    scope: SCOPE
  })
}

export function logout (cb) {
  clearIdToken()
  clearAccessToken()
  clearLocalData(PROFILE_KEY)
  clearCurrentPage()
  if (cb) {
    cb()
  }
}

export function requireAuth (to, from, next) {
  if (!isLoggedIn()) {
    saveTargetPath(to.fullPath)
    next(false)
    login()
  } else {
    next()
  }
}

export function getIdToken () {
  return localStorage.getItem(ID_TOKEN_KEY)
}

export function getAccessToken () {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY)
  return accessToken
}

function clearIdToken () {
  localStorage.removeItem(ID_TOKEN_KEY)
}

function clearAccessToken () {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

// Helper function that will allow us to extract the access_token and id_token
export function getParameterByName (name) {
  let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
}

// Get and store access_token in local storage
export function setAccessToken () {
  let accessToken = getParameterByName('access_token')
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
}

// Get and store id_token in local storage
export function setIdToken () {
  let idToken = getParameterByName('id_token')
  localStorage.setItem(ID_TOKEN_KEY, idToken)
}

export function isLoggedIn () {
  const idToken = getIdToken()
  return !!idToken && idToken !== 'null' && !isTokenExpired(idToken)
}

export function getIsTester () {
  const profile = getProfile()
  const key = NON_OIDC_NAMESPACE + 'app_metadata'
  if (profile && profile.hasOwnProperty(key)) {
    return profile[key].isTester
  } else {
    return false
  }
}

export function getProfile () {
  const localProfile = getLocalData(PROFILE_KEY)
  if (localProfile) {
    return JSON.parse(localProfile)
  } else {
    return null
  }
}

export function initialiseProfile (cb) {
  const accessToken = getAccessToken()
  if (accessToken) {
    try {
      auth.client.userInfo(accessToken, (err, profile) => {
        if (profile) {
          saveLocalData(PROFILE_KEY, JSON.stringify(profile))
          cb()
        } else {
          console.warn('Unable to fetch user profile')
          console.warn(err)
          cb()
        }
      })
    } catch (e) {
      console.warn('Unable to fetch userInfo', e)
      cb()
    }
  } else {
    console.warn('No access token available for getProfile')
    cb()
  }
}

export function getUserId () {
  const profile = getProfile()
  if (profile) {
    return profile.sub
  } else {
    return null
  }
}

function setUserData (d) {
  let auth0Manage = new auth0.Management({
    domain: CLIENT_DOMAIN,
    token: getAccessToken()
  })
  auth0Manage.patchUserMetadata(getUserId(), d, (e) => {})
}

export function setHasSeenTour () {
  setUserData({has_seen_tour: true})
}

export function hasSeenTour () {
  const profile = getProfile()
  if (profile) {
    return profile.has_seen_tour
  } else {
    return false
  }
}

export function isEmailVerified () {
  const profile = getProfile()
  if (profile) {
    return profile.email_verified
  } else {
    return false
  }
}

function getTokenExpirationDate (encodedToken) {
  const token = decode(encodedToken)
  if (!token.exp) { return null }

  const date = new Date(0)
  date.setUTCSeconds(token.exp)

  return date
}

function isTokenExpired (token) {
  const expirationDate = getTokenExpirationDate(token)
  return expirationDate < new Date()
}

export function saveCurrentPage () {
  localStorage.setItem(CURRENT_PAGE_KEY, window.location)
}

export function fetchLastCurrentPage () {
  return localStorage.getItem(CURRENT_PAGE_KEY)
}

export function saveTargetPath (targetPath) {
  localStorage.setItem(TARGET_PATH_KEY, targetPath)
}

export function fetchTargetPath () {
  return localStorage.getItem(TARGET_PATH_KEY)
}

export function clearTargetPath () {
  localStorage.removeItem(TARGET_PATH_KEY)
}

export function clearCurrentPage () {
  localStorage.removeItem(CURRENT_PAGE_KEY)
}

export function saveLocalData (key, data) {
  localStorage.setItem(LOCAL_DATA_KEY + key, data)
}

export function getLocalData (key) {
  return localStorage.getItem(LOCAL_DATA_KEY + key)
}

export function clearLocalData (key) {
  localStorage.removeItem(LOCAL_DATA_KEY + key)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js